(function(){
  const specs=[
    {terms:["bellacanvas3010"],lines:[
      "203 gsm • 100% Airlume combed ring-spun cotton",
      "20 singles • Heavyweight",
      "Drop shoulder • Relaxed boxy fit • Side-seamed"
    ]},
    {terms:["atcwerk250"],lines:[
      "250 gsm • 100% combed ring-spun cotton (standard colours)",
      "Ultra heavyweight • Relaxed fit",
      "Drop shoulder • Side-seamed • Tear-away label"
    ]},
    {terms:["shakawearmaxheavyweightgarmentdye"],lines:[
      "255–260 gsm • 100% USA cotton",
      "16 singles • Garment-dyed heavyweight",
      "Slightly oversized fit • Dense knit • Vintage wash"
    ]},
    {terms:["atcwerk420"],lines:[
      "420 gsm • 80/20 cotton/poly fleece (most colours)",
      "3-end fleece • 100% cotton face (excl. safety)",
      "Relaxed fit • Jersey-lined hood • No drawstring"
    ]},
    {terms:["independentind4000"],lines:[
      "330 gsm • 70/30 cotton/poly 3-end fleece (solids)",
      "100% cotton face yarn • Generous fit",
      "Fleece-lined hood • Heavy gauge drawcord • 1×1 rib"
    ]}
  ];

  function compact(text){
    return (text||"").toLowerCase().replace(/[^a-z0-9]+/g,"");
  }

  function closeAll(except){
    document.querySelectorAll(".garment-info.is-open").forEach(function(info){
      if(info===except)return;
      info.classList.remove("is-open");
      const btn=info.querySelector(".garment-info__button");
      if(btn)btn.setAttribute("aria-expanded","false");
    });
  }

  function addInfo(card,spec){
    if(card.querySelector(".garment-info"))return;

    const wrapper=document.createElement("div");
    wrapper.className="garment-info";

    const button=document.createElement("button");
    button.type="button";
    button.className="garment-info__button";
    button.textContent="i";
    button.setAttribute("aria-label","View garment specifications");
    button.setAttribute("aria-expanded","false");

    const tooltip=document.createElement("div");
    tooltip.className="garment-info__tooltip";
    tooltip.setAttribute("role","tooltip");

    spec.lines.forEach(function(line){
      const span=document.createElement("span");
      span.className="garment-info__line";
      span.textContent=line;
      tooltip.appendChild(span);
    });

    wrapper.append(button,tooltip);
    card.appendChild(wrapper);

    wrapper.addEventListener("pointerdown",function(e){e.stopPropagation();});
    wrapper.addEventListener("click",function(e){e.stopPropagation();});

    button.addEventListener("click",function(e){
      e.preventDefault();
      e.stopPropagation();
      const open=wrapper.classList.contains("is-open");
      closeAll(wrapper);
      wrapper.classList.toggle("is-open",!open);
      button.setAttribute("aria-expanded",open?"false":"true");
      if(open)button.blur();
    });
  }

  function init(){
    document.querySelectorAll(".pricing-page-scope .multicolumn-card").forEach(function(card){
      if(card.querySelector(".garment-info"))return;
      const text=compact(card.textContent);
      const spec=specs.find(function(item){
        return item.terms.every(function(term){return text.includes(compact(term));});
      });
      if(spec)addInfo(card,spec);
    });
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",init,{once:true});
  }else{
    init();
  }

  document.addEventListener("shopify:section:load",init);
})();
